module.exports = __webpack_public_path__ + "media/target_area_icon/dept_security-6815933a.png";